var render, staticRenderFns
import script from "./NsCarouselItems.vue?vue&type=script&lang=js&"
export * from "./NsCarouselItems.vue?vue&type=script&lang=js&"
import style0 from "./NsCarouselItems.vue?vue&type=style&index=0&id=26638c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26638c2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26638c2e')) {
      api.createRecord('26638c2e', component.options)
    } else {
      api.reload('26638c2e', component.options)
    }
    
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsCarouselItems.vue"
export default component.exports